export default __webpack_public_path__ + "static/media/dia8.282ad2b0.png";